<div class="evenement-planning {{ typeEvenement() }}">
	<p-panel [toggleable]="true" toggler="header" styleClass="{{ typeEvenement() }}">
		<ng-template pTemplate="header">
			<i class="pi {{ iconeEvenement() }}"></i>
			<span>{{ titreSection() }}</span>
		</ng-template>
		<ng-template pTemplate="headericons" let-collapsed>
			@if (collapsed) {
				<span class="pi pi-chevron-down" style="color: #FFF"></span>
			} @else {
				<span class="pi pi-chevron-up" style="color: #FFF"></span>
			}
		</ng-template>
		<div class="evenement-planning-content">
			@for (evenementPlanning of evenementsPlannings(); track evenementPlanning) {
				<div class="utilisateur-evenement-planning">
					<span>{{ evenementPlanning.prenomNomUtilisateur }}</span>
					@if (evenementPlanning.dureeEvenement.code === Duree.MATIN) {
						<i class="pi pi-sun" pTooltip="{{ 'PLANNING.TOOLTIP_PRESENCE_MATIN' | translate }}"></i>
					}
					@if (evenementPlanning.dureeEvenement.code === Duree.APRES_MIDI) {
						<i class="pi pi-moon" pTooltip="{{ 'PLANNING.TOOLTIP_PRESENCE_APRES_MIDI' | translate }}"></i>
					}
				</div>
			}
		</div>
	</p-panel>
</div>
